export * from "./notifs_errors";
export * from "./notifs_success";
export * from "./containers_constants";
export const SURVEY_STATUS = {
  DRFT: "DRFT",
  CLOS: "CLOS",
};
